export default __webpack_public_path__ + "static/media/success.9d837fff.svg";